

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState, Fragment } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import customStyles from "../../../../../assets/styles/customStyles";
import { CustomForm } from './CustomForm';
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { AESDecrypt } from "../../../../../helpers/Crypto";
import { toast } from 'react-toastify';
import { checkCRUDViewPermission } from "../../../../../helpers/utilities";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";


const PurchaseQuoteCreate = (props) => {
    const { readDetails, readError } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const formRef = useRef('');
    const { history } = props;
    const dispatch = useDispatch();
    let { quoteId } = useParams();
    const decryptedId = AESDecrypt(quoteId);
    const [view, setView] = useState(false);
    const { type } = useParams();
    const prevReadDetails = usePrevious(readDetails);
    const [showDetails, setShowDetails] = useState(true);



    useEffect(() => {
        if (quoteId !== undefined && decryptedId === 0) {
            history.push('/purchase/purchase-management/supply-quote');
            return true;
        }
        if (roleManagement !== '' && checkCRUDViewPermission('Supply Quote', type, history, 'Purchase')) {
            loadTask();
        }
        if (type === 'view') {
            setView(true);
        } else {
            setView(false);
        }

    }, [quoteId, type, roleManagement]);


    const loadTask = () => {
        if (quoteId) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "supply-quotes" });
        }
    }


    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            if (type === 'view' || readDetails?.supply_quote_status === 'DELIVERED' || readDetails?.supply_quote_status === 'ORDERED' ||
                (readDetails?.inAppTransition && readDetails?.supply_quote_status === 'REQUESTED') || readDetails?.supply_quote_status === 'ACCEPTED'
                || readDetails?.supply_quote_status === 'RECEIVED') {
                setView(true);
            } else {
                setView(false);
            }
            formRef.current.onEdit(readDetails);
        } else if (readError) {
            if (readError.error.statusCode) {
                toast.error('Purchase Quote ID is invalid');
                history.push('/purchase/purchase-management/supply-quote');
            }
        }
    }, [readDetails, readError]);

    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'} img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' },
            { 'label': 'Quotation', 'link': '' }]}
                handleCloseClick={() => type === 'create' ? history.go(-1) : history.push('/purchase/purchase-management/supply-quote')}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky,
                { [classes.scrollBorder]: type === 'create' ? true : !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomForm
                        ref={formRef}
                        showDetails={type === 'create' ? false : showDetails}
                        view={view}
                        quoteId={quoteId === undefined ? quoteId : decryptedId}
                        type={type}
                        roleManagement={roleManagement}
                        loadTask={() => loadTask()}
                        classes={classes}
                        dispatch={dispatch}
                        clsx={clsx}
                        {...props}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default PurchaseQuoteCreate